import React, { useContext } from 'react';
import styled from 'styled-components';
import PropertiesFiltersContext from '../../context/PropertiesFiltersContext';
import { GridIcon, ListViewIcon } from '../../icons';

const ListTypeToggle: React.FC = () => {
  const { listingType, setListingType } = useContext(PropertiesFiltersContext);
  return (
    <Container>
      <Button
        className={listingType === 'list' ? 'active' : ''}
        onClick={() => setListingType('list')}
      >
        <ListViewIcon />
      </Button>
      <Button
        className={listingType === 'grid' ? 'active' : ''}
        onClick={() => setListingType('grid')}
      >
        <GridIcon />
      </Button>
    </Container>
  );
};

const Container = styled.div`
  display: none;
  ${(props) => props.theme.mq.desktop} {
    display: flex;
    align-items: center;
  }
`;

const Button = styled.button`
  padding: 0;
  background-color: transparent;
  border: none;
  cursor: pointer;
  outline: none;
  svg {
    fill: rgb(117, 117, 117);
  }
  &.active {
    svg {
      fill: ${(props) => props.theme.colors.primary};
    }
  }
  &:not(:last-of-type) {
    margin-right: 8px;
  }
`;

export default React.memo(ListTypeToggle);
